

















ENV = require "config/env"
FUNCTIONS = require "scripts/common"
WP = require "scripts/wordpress"
module.exports =
	props: ["description", "latests"]
	components:
		postLink: require "components/archive/posts/postLink"
		spinner: require "components/common/spinner"
	data: ->
		pages: [ENV.pages[4],ENV.pages[1],ENV.pages[2],ENV.pages[3]]
	computed:
		isEnglish: -> return FUNCTIONS.judgeIsEnglish(this.$route)
		toCategory: ->
			name = if !this.isEnglish then "posts" else "en_posts"
			return {name: name, params: {projectName: "all", category: "all", page: 1}}
	methods:
		renderText: (ja, en) -> return if !this.isEnglish then ja else en
		toAboutPage: (projectSlug) -> return {name: "about", params:{projectName: projectSlug}}
		getProjectSlug: (post) ->
			for category in ENV.categories then if WP.hasCategory(post, category.id) then return category.slug



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/top/pageTemplate.vue